import React from 'react'
import clsx from 'clsx'
import { PersonLiteDto } from '../../../api/person/models/PersonDto'
import { formatPersonName } from '../../../utils/personUtils'
import Badge from '../badge/Badge'
import { BadgeColor } from '../badge/badgeTypes'
import ProfilePic from './ProfilePic'

const looksLikeLinkedInPlaceholder = (url?: string): boolean => {
    if (!url) {
        return false
    }
    const normalized = url.toLowerCase()
    if (
        normalized.includes('ghost') ||
        normalized.includes('placeholder') ||
        normalized.includes('default')
    ) {
        return true
    }
    return /profile-displayphoto-shrink_\d+_\d+\/0\/0\//.test(normalized)
}

type Props = {
    person: PersonLiteDto
    size?: number
    className?: string
    rightIcon?: React.ReactNode
}

export default function PersonBadge({
    person,
    size = 28,
    className,
    rightIcon,
}: Props): React.JSX.Element {
    const name = formatPersonName(person)
    const src = looksLikeLinkedInPlaceholder(person.linkedInProfilePicUrl)
        ? '/no-profile-pic.svg'
        : person.linkedInProfilePicUrl || '/no-profile-pic.svg'
    const jobFunction =
        person.department?.trim() ||
        person.currentJobDetails?.workedAt?.department?.trim() ||
        ''

    return (
        <div
            className={clsx(
                'inline-flex items-start gap-2 rounded-lg border border-gray-200 bg-white px-2 py-1 shadow-sm',
                className,
            )}
        >
            <ProfilePic
                src={src}
                size={size}
                alt={name || 'Trusted Circle contact'}
            />
            <div className="flex min-w-0 flex-col items-start">
                <span className="text-sm text-gray-900 leading-tight">
                    {name}
                </span>
                {jobFunction ? (
                    <Badge
                        color={BadgeColor.Violet}
                        className="mt-0.5 text-sm"
                        borderless={true}
                        title={jobFunction}
                    >
                        {jobFunction}
                    </Badge>
                ) : null}
            </div>
            {rightIcon ? <div className="self-center">{rightIcon}</div> : null}
        </div>
    )
}
